import React, { useContext } from 'react';
import { Button } from '@components';
import { StepperContext } from '@components/Stepper';
import { useIsMobile } from '@hooks';
import { Stack, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const AnotherSubmissionStep: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const { goToNextStep } = useContext(StepperContext);

  return (
    <Stack alignItems="center" gap={4} sx={{ my: theme.spacing(5) }}>
      <Typography variant="h2" textAlign="center">
        <FormattedMessage id="preparingForNextSubmission.step.1.title" />
      </Typography>
      <Stack direction="row" gap={isMobile ? 2 : 3}>
        <Button variant="outlined" onClick={() => navigate('/submission-creation')}>
          <FormattedMessage id="common.no" />
        </Button>
        <Button variant="contained" onClick={goToNextStep}>
          <FormattedMessage id="common.yes" />
        </Button>
      </Stack>
    </Stack>
  );
};

export default AnotherSubmissionStep;
